import { useXmlDataStore } from './useXmlDataStore';
import { useSafeNavigation } from './useSafeNavigation';

export const useXmlProcessController = () => {
  const { xmlDataModel } = useXmlDataStore();
  const { safeNavigate } = useSafeNavigation();

  if (xmlDataModel.isEmpty) {
    safeNavigate('/upload', { replace: true });
  }

  const updateXmlProcess = () => {
    if (xmlDataModel.isEmpty) {
      safeNavigate('/upload', { replace: true });
      return;
    }

    if (xmlDataModel.batchId) {
      safeNavigate(`/upload/batch/${xmlDataModel.batchId}/billing`);
      return;
    }

    if (!xmlDataModel.contactsConfirmed && xmlDataModel.hasCustomerWithoutContactInfo()) {
      safeNavigate('/upload/xml/complete-data');
      return;
    }

    if (xmlDataModel.hasContactToUpsert()) {
      safeNavigate('/upload/xml/upsert-contacts');
      return;
    }

    safeNavigate('/upload/xml/create-batch');
  };

  return {
    updateXmlProcess,
  };
};
